import 'angular-object-diff';

(function() {
  'use strict';

  angular.module('blocks.utils', ['ds.objectDiff']);
})();
